import { Injectable } from '@tanbo/vue-di-plugin'
import { TableList, TableMemoryPagination } from '@/services/table-memory-pagination'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { AuthStatusList } from '@/views/dashboard/_type/client-item'
import { getAreaByTerminalType } from '@/services/service-permission.service'

/* eslint-disable no-magic-numbers */
export enum CheckResult {
  pass=1,
  unPass=2,
  all=3
}

export interface QueryParams {
  /** 分组id */
  group_id: number
  /** 计算机名 / 登记用户名 */
  key_word?: string
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序 */
  asc?: boolean
  /** 排序字段 */
  sort?: string
  /** 是否使用内存数据 */
  useMemory: boolean
  /** 基线检查结果，1为合规，2为不合规，3为全部 */
  check_result: number
  permission_names?: string[]
}
export interface TerminalItem {
  /** 终端设备id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 内网ip */
  system_ip: string
  /** 外网ip */
  client_ip: string
  /** 操作系统名 */
  system_name: string
  /** 上次扫描时间戳,单位秒 */
  last_check_time: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  /** 登录状态,1-在线，2-离线 */
  login_status: number
  /** 授权状态集合 */
  auth_status?: AuthStatusList[]
  /** 前端字段 */
  area_type?: number
}
export interface ScanParams {
  /** 选择类型,0-指定终端，1-指定分组 */
  select_type: number
  /** 终端设备id列表 */
  device_list: string[]
  /** 分组id */
  group_id: number
}

export interface ScanResult {
  /** 已发现不合规终端数量 */
  substandard_count: number
  /** 检测总数 */
  check_total: number
  /** 是否已完成 */
  is_finish: boolean
}

@Injectable()
export class BaseLineScanTerminalDrawerService extends TableMemoryPagination<QueryParams, TerminalItem> {
  constructor (private http: Http) {
    super()
  }

  isEqual (left: TerminalItem, right: TerminalItem): boolean {
    return left.device_id === right.device_id
  }

  @ParamsClean()
  getListByServer (params: QueryParams): Promise<TableList<TerminalItem>> {
    return this.http.post<{
      list: TerminalItem[]
      enable_total: number
      total: number
    }>('/baselinecheck/terminals/check-notify/get', params).then(res => {
      res.list.forEach(v => v.area_type = getAreaByTerminalType(v.system_type))
      return res
    })
  }

  getRescan (data: ScanParams) {
    return this.http.post<{
      task_id: string
      device_count: number
    }>('/baselinecheck/check', data)
  }

  getScanResult (data: { task_id: string }) {
    return this.http.post<ScanResult>('/baselinecheck/check-result', data)
  }
}
